import { render, staticRenderFns } from "./BkashGCECallback.vue?vue&type=template&id=40f5c295&scoped=true&"
import script from "./BkashGCECallback.vue?vue&type=script&lang=js&"
export * from "./BkashGCECallback.vue?vue&type=script&lang=js&"
import style0 from "./BkashGCECallback.vue?vue&type=style&index=0&id=40f5c295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f5c295",
  null
  
)

export default component.exports